import type { WP_REST_API_Category, WP_REST_API_Post } from 'wp-types';

export type WpPost = WP_REST_API_Post;
export type WpPostPreview = Pick<
  WpPost,
  'id' | 'slug' | 'title' | '_embedded' | '_links' | 'categories' | 'date' | 'excerpt'
>;
export type WpCategory = WP_REST_API_Category;

export default (fetch: typeof $fetch) => ({
  getBySlug: async (slug: string) => {
    const response = await fetch<WpPost[]>('/wp/v2/posts', {
      query: {
        slug,
        acf_format: 'standard'
      }
    });

    return response?.[0];
  },

  getPreviews: async ({
    page = 1,
    perPage = 7,
    orderby = 'date',
    order = 'desc',
    categories,
    search,
    include
  }: {
    page?: number;
    perPage?: number;
    orderby?: 'date';
    order?: 'desc' | 'asc';
    categories?: number;
    search?: string;
    include?: string;
  } = {}) => {
    let category;
    if (categories === 1) {
      category = undefined;
    }
    else {
      category = categories;
    }

    const response = await fetch.raw<WpPostPreview[]>('/wp/v2/posts', {
      query: {
        page,
        per_page: perPage,
        orderby,
        order,
        categories: category,
        search,
        include,
        acf_format: 'standard',
        _fields: 'id,slug,title,_embedded,_links.wp:featuredmedia,categories,date,excerpt',
        _embed: true
      }
    });

    const posts = response._data?.map((post) => ({
      ...post,
      thumbnail: post?._embedded?.['wp:featuredmedia']?.[0],
      excerpt: post?.excerpt.rendered
    }));

    const total = parseInt(response.headers.get('x-wp-total') || '0');

    return { posts, total };
  },

  getCats: async () => {
    const response = await fetch<WpCategory[]>('/wp/v2/categories', {
      query: {
        per_page: 100
      }
    });
    return response;
  }
});
